import { render, staticRenderFns } from "./apikeys.vue?vue&type=template&id=561197a2&"
import script from "./apikeys.vue?vue&type=script&lang=js&"
export * from "./apikeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports